import { render, staticRenderFns } from "./performance-business-score-card.vue?vue&type=template&id=b50a890a"
import script from "./performance-business-score-card.vue?vue&type=script&lang=js"
export * from "./performance-business-score-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports